"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogCloseButtonWidget = exports.CloseButtonWidget = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Localize_1 = require("../../../gen-src/Localize");
var Icons_1 = require("../../icons/Icons");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var ButtonWidget_1 = require("./ButtonWidget");
var ButtonWidgetShim_1 = require("./ButtonWidgetShim");
// tslint:disable:max-line-length
var CloseButtonSvg = function (fillColor) {
    if (fillColor === void 0) { fillColor = '#666'; }
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"$state$\" width=\"14\" height=\"14\">\n<path fill=\"" + fillColor + "\" d=\"M7.7 7l4.7-4.7c.2-.2.2-.5 0-.7s-.5-.2-.7 0L7 6.3 2.3 1.6c-.2-.2-.5-.2-.7 0s-.2.5 0 .7L6.3 7l-4.7 4.7c-.2.2-.2.5 0 .7s.5.2.7 0L7 7.7l4.7 4.7c.2.2.5.2.7 0s.2-.5 0-.7L7.7 7z\"/>\n</svg>";
};
// tslint:enable:max-line-length
var CloseButtonStyleName = TypeStyle.style({
    $nest: {
        '&&': { minHeight: 18, minWidth: 18, height: 18, width: 18 },
        '&.dark': { cursor: 'pointer' },
        '&::before': {
            content: "url(" + Icons_1.encodeSvg(CloseButtonSvg('#666')) + ")",
            display: 'inline-block',
            height: 14,
            width: 14,
        },
        '&:active::before, &:hover::before': {
            content: "url(" + Icons_1.encodeSvg(CloseButtonSvg('#333')) + ")",
        },
        '&.prominent::before': {
            content: "url(" + Icons_1.encodeSvg(CloseButtonSvg('#333')) + ")",
        },
        '&.prominent:active::before, &.prominent:hover::before': {
            content: "url(" + Icons_1.encodeSvg(CloseButtonSvg('#000')) + ")",
        },
        '&.dark::before': {
            content: "url(" + Icons_1.encodeSvg(CloseButtonSvg('#fff')) + ") !important",
        }
    }
});
exports.CloseButtonWidget = React.forwardRef(function (props, ref) {
    var useDarkStyling = props.useDarkStyling, buttonProps = tslib_1.__rest(props, ["useDarkStyling"]);
    return React.createElement(ButtonWidgetShim_1.ButtonWidget, tslib_1.__assign({}, buttonProps, { buttonType: ButtonWidget_1.ButtonType.IconOutline, className: TypeStyle.classes(props.className, CloseButtonStyleName, useDarkStyling && 'dark'), ref: ref, title: props.title || Localize_1.Messages.close() }));
});
exports.CloseButtonWidget.displayName = 'CloseButtonWidget';
var TapTargetStyleName = TypeStyle.style({
    alignItems: 'center',
    backgroundClip: 'content-box',
    boxSizing: 'border-box',
    cursor: 'auto',
    display: 'flex',
    flexShrink: 0,
    height: 30,
    justifyContent: 'center',
    outline: 'none',
    padding: 6,
    width: 30,
    $nest: {
        '&:hover': { backgroundColor: TabStyles_1.TabStyles.Colors.F3 },
        '&:hover>button::before': {
            content: "url(" + Icons_1.encodeSvg(CloseButtonSvg('#333')) + ")",
        },
        // hacks to hide the focus indicator for mouse
        '& > button:active': { boxShadow: 'none !important' },
        '& > button:active::after': { display: 'none !important' },
    }
});
exports.DialogCloseButtonWidget = React.forwardRef(function (props, ref) {
    return React.createElement("div", tslib_1.__assign({}, ReactHelpers_1.EventUtilsOptOut, { className: TapTargetStyleName, onClick: props.onClick, ref: ref }),
        React.createElement(exports.CloseButtonWidget, tslib_1.__assign({}, props, { "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'CloseButton'), onClick: function (e) { var _a; e.stopPropagation(); (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e); }, testId: null })));
});
exports.DialogCloseButtonWidget.displayName = 'DialogCloseButtonWidget';
//# sourceMappingURL=CloseButtonWidget.js.map